import React from 'react';
import { Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import RevenueManagerPage from '../Pages/RevenueManagerPage';

LoadingOverlay.propTypes = undefined;

function RevenueManagerRoute() {
  const history = useHistory();

  return (
    <Switch>
      <Route
        exact
        path="/:lng/revenue-manager"
        render={() => (
          <Auth history={history} allowedRoles={['admin', 'staff', "revenue_manager", "revenue_staff"]}>
            {/* <Suspense fallback={<Loading />}> */}
            <RevenueManagerPage history={history} />
            {/* </Suspense> */}
          </Auth>
        )}
      />
    </Switch>
  );
}

export default RevenueManagerRoute;

function Loading() {
  return (
    <>
      <LoadingOverlay
        active={true}
        spinner={<FadeLoader />}
        text='Loading Revenue Manager...'
      />
    </>
  );
}
